// pt-BR main system pages modules

import system from './system';

export default {
  pages: {
    ...system,
  },
};
